











import VideoBg from "@/components/VideoBg.vue";
import Menu from "@/components/Menu.vue";
import Title from "@/components/Title.vue";
import * as Tone from "tone";

export default {
  name: "App",
  components: {
    VideoBg,
    Menu,
    Title
  },
  mounted() {
const player = new Tone.Player({
	"url" : "https://res.cloudinary.com/nancloud/video/upload/v1606204834/LSD/SOUNDS/dojo_nzufev.mp3",
  "autostart" : false,
  "volume" : -6,
  "loop": false,
}).toDestination();
  }
};
